import React from 'react';

const ContentOptimizerIcon = ({ color = '#9199AD', size = '20' }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M2.9167 17.0835C3.60837 17.7752 4.72503 17.7752 5.4167 17.0835L16.25 6.2502C16.9417 5.55853 16.9417 4.44186 16.25 3.7502C15.5584 3.05853 14.4417 3.05853 13.75 3.7502L2.9167 14.5835C2.22503 15.2752 2.22503 16.3919 2.9167 17.0835Z'
                stroke={color}
                strokeWidth='1.2'
                strokeLinecap='round'
            />
            <path
                d='M15.0083 7.49121L12.5083 4.99121'
                stroke={color}
                strokeWidth='1.2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M7.08337 2.03366L8.33337 1.66699L7.96671 2.91699L8.33337 4.16699L7.08337 3.80033L5.83337 4.16699L6.20004 2.91699L5.83337 1.66699L7.08337 2.03366Z'
                stroke={color}
                strokeLinecap='round'
            />
            <path
                d='M3.75 7.03366L5 6.66699L4.63333 7.91699L5 9.16699L3.75 8.80033L2.5 9.16699L2.86667 7.91699L2.5 6.66699L3.75 7.03366Z'
                stroke={color}
                strokeLinecap='round'
            />
            <path
                d='M16.25 11.1997L17.5 10.833L17.1333 12.083L17.5 13.333L16.25 12.9663L15 13.333L15.3667 12.083L15 10.833L16.25 11.1997Z'
                stroke={color}
                strokeLinecap='round'
                id='stroke-star'
            />
        </svg>
    );
};

export default ContentOptimizerIcon;
